module.exports = __webpack_public_path__ + "img/1518307407.4bc04659.jpg";